"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const UserInfoAvatar_1 = require("@Components/UserInfoAvatar");
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const TopSection = (props) => {
    const { userInfo, isInternal, onClick } = props;
    return (react_1.default.createElement("div", { className: "profile-info" },
        react_1.default.createElement(UserInfoAvatar_1.UserInfoAvatar, { userInfo: userInfo }),
        !isInternal && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: onClick }, "Edit"))));
};
exports.default = TopSection;
